import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ItemStockComponentStore } from 'products-data';
import { ItemComponentBase, RenderInItemStockDirective } from 'products-ui';
import { PunchoutItemPricingComponentStore } from 'punchout-data';
import { LeadTimeNotificationChipComponent } from '../lead-time-notification-chip/lead-time-notification-chip.component';

@Component({
  selector: 'ideal-punchout-item-stock-provider',
  standalone: true,
  providers: [PunchoutItemPricingComponentStore],
  imports: [MatIconModule, LeadTimeNotificationChipComponent, RenderInItemStockDirective],
  templateUrl: './punchout-item-stock-provider.component.html',
  styleUrl: './punchout-item-stock-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PunchoutItemStockProviderComponent extends ItemComponentBase {
  private readonly stockStore = inject(ItemStockComponentStore);
  protected readonly itemStock = computed(() => this.stockStore.itemStock());
  protected readonly stockLocation = computed(() => this.stockStore.itemStock()?.stockLocation);

  constructor() {
    super();
    effect(() => this.stockStore.selectItemStockById(this.id()));
  }
}
